import { Fragment } from 'react';

import { ReactComponent as ArrowIcon } from '@assets/img/icons/arrow-down.svg';

import { CircularProgress, TextField } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Autocomplete from '@material-ui/lab/Autocomplete';

const NibAsyncAutoComplete = ({
  value = null,
  onChange = () => {},
  label = '',
  options = [],
  required = false,
  loading = false,
  handleInput,
  helperText = false,
  placeholder = '',
  error = false,
  wrapperProps,
  inputProps,
  ...props
}) => {
  const handleSelection = (val) => {
    onChange(val);
  };

  const useOutlinedInputStyles = makeStyles({
    root: {
      '& fieldset': {
        color: '#fff',
        outlineColor: 'rgba(255, 255, 255, 0.3);',
        borderColor: '#232323 !important',
      },
    },
  });

  const outlinedInputStyles = useOutlinedInputStyles();

  return (
    <Autocomplete
      options={options}
      onChange={(e, val) => handleSelection(val)}
      autoHighlight
      classes={{ inputRoot: 'h-full' }}
      getOptionLabel={(option) => option.name || ''}
      getOptionSelected={(option, value) => option.id === value.id}
      loading={loading}
      loadingText={<CircularProgress color={'primary'} />}
      value={value}
      popupIcon={<ArrowIcon />}
      renderOption={(option) => <Fragment>{option.name}</Fragment>}
      renderInput={(params) => (
        <TextField
          {...params}
          error={error}
          required={required}
          label={label}
          variant="outlined"
          onChange={(e) => handleInput(e.target.value)}
          placeholder={placeholder}
          helperText={helperText}
          classes={outlinedInputStyles}
          inputProps={{
            ...params.inputProps,
            autoComplete: 'off', // disable autocomplete and autofill
            ...props,
          }}
          {...inputProps}
        />
      )}
      {...wrapperProps}
      {...props}
    />
  );
};

export default NibAsyncAutoComplete;
